import * as React from 'react';
import { removeRole } from '../../../redux/actions/serverApi.actions';
import { connect, ConnectedProps } from 'react-redux';
import { InjectedTranslateProps, translate, Trans } from 'react-i18next';
import { MessageBoxFunctionalLayout, Text } from 'wix-style-react';

export interface IRemoveRoleModal extends InjectedTranslateProps, ConnectedProps<typeof connector> {
  closeModal(): void;
  idToRemove: string;
  roleName: string;
  onOk: () => void;
}

export class RemoveRoleComponent extends React.PureComponent<IRemoveRoleModal> {

  onOk = () => {
    const { onRemoveClicked, closeModal, idToRemove, onOk } = this.props;
    onRemoveClicked(idToRemove);
    closeModal();
    if (onOk) { onOk(); }
  }

  render() {
    const { closeModal, roleName, t } = this.props;

    return (
      <MessageBoxFunctionalLayout
        dataHook="remove-role-layout"
        title={t('app.removeRole.title')}
        confirmText={t('app.removeRole.removeCTA')}
        cancelText={t('app.removeRole.cancelCTA')}
        onCancel={closeModal}
        onClose={closeModal}
        onOk={this.onOk}
        theme="red"
        width="540px"
      >
        <Trans i18nKey="app.removeRole.description"
               values={{ roleName }}>
          <Text>Are you sure you want to remove</Text>
          <Text weight="normal">roleName</Text>
          <Text>role?</Text>
        </Trans>
      </MessageBoxFunctionalLayout>
    );
  }
}

const mapDispatchToProps = {
  onRemoveClicked: removeRole
};

const connector = connect(null, mapDispatchToProps);
export const RemoveRole = connector(translate()(RemoveRoleComponent));
